import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { selectUserOrganizationPolicies } from '../../store/slices/user-policies.slice';
import { UserOrganizationPolicyDto } from '../../commonTypes/acs/user.types';

export const useUserOrganizationPolicies = () => useSelector<RootState, UserOrganizationPolicyDto[]>(selectUserOrganizationPolicies);
